export default __webpack_public_path__ + "static/media/debbie.d08fe843.png";